import { Component } from "react";

import { PASSWORD_EVALUATOR } from "library/validator";
import { Input } from "../Input/Input";
import { SvgInline } from "../SvgInline/SvgInline";

import styles from "./password-input.module.scss";

class PasswordInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "password",
      value: "",
      error: props.error || false,
      success: false,
      showError: props.error || false,
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const value = event.value.replace(/\s/g, "");
    let error = false;
    let success = true;

    if (this.props.evaluator) {
      // error = this.state.inValid;

      PASSWORD_EVALUATOR.map((item) => {
        if (!item.success(value)) {
          success = false;
          return null;
        }
        return null;
      });
    } else {
      error = !value ? "Enter a password" : false;
      success = value;
    }
    this.setState(
      {
        value,
        success,
        error,
        showError: event.type === "blur",
      },
      () => {
        if (typeof this.props.onChange === "function") {
          this.props.onChange(this.state);
        }
      },
    );
  }

  render() {
    const label = this.props.label || "Password";
    const error = this.state.error || this.props.error;

    // TODO: confirm with Sameer about error prop
    return (
      <Input
        type={this.state.type}
        label={label}
        onChange={this.onChange}
        error={error}
        success={this.props.evaluator && this.state.success}
        disabled={this.props.disabled}
        maxLength={256}
        className={`${this.props.className} ${styles.input}`}
      >
        <div
          id="show-hide-password"
          role="button"
          tabIndex={-1}
          className={styles.icon}
          onClick={() => {
            const { type } = this.state;
            this.setState({
              type: type === "password" ? "text" : "password",
            });
          }}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              const { type } = this.state;
              this.setState({
                type: type === "password" ? "text" : "password",
              });
            }
          }}
        >
          <SvgInline
            name={
              this.state.type === "password"
                ? "icon-Eye-Hidden"
                : "icon-Eye-Visible"
            }
          />
        </div>

        {this.props.evaluator && (
          <div className={styles.evaluator}>
            {PASSWORD_EVALUATOR.map((item) => {
              let itemClass = styles.item;
              let iconClass = styles.itemIcon;
              if (item.success(this.state.value)) {
                itemClass = styles.success;
                iconClass = styles.iconSuccess;
              }

              return (
                <div
                  data-trackid="password-evaluator"
                  className={itemClass}
                  key={item.label}
                >
                  <div className={iconClass}>
                    <SvgInline name="icon-tick-small" />
                  </div>
                  {item.label}
                </div>
              );
            })}
          </div>
        )}
      </Input>
    );
  }
}

export { PasswordInput };
